import React, { useState, useEffect } from 'react';
import { API_URL } from '../../../actions';

import edit from '../../../assets/images/icons/edit.svg';
import remove from '../../../assets/images/icons/remove.svg';
import close from '../../../assets/images/icons/close.svg';
import save from '../../../assets/images/icons/save.svg';

export default function EditKnowledge({ knowledgeValue, knowledges, setKnowledges, index, theme, openSelectKnowledgePicture, setRemoveAction, context }) {

  const [knowledge, setKnowledge] = useState(knowledgeValue || {});
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (!knowledgeValue?.picture && !knowledgeValue?.text) {
      setIsEdit(true);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setKnowledge(knowledgeValue || {});
  }, [knowledgeValue]);

  function save_() {
    var list = knowledges ? [...knowledges] : [];
    list[index] = knowledge;
    setKnowledges([...list]);
    setIsEdit(false);
  }

  function renderImg(className) {
    if (knowledge.picture && context.medias.mediasList) {
      const found = context.medias.mediasList.find(m => m._id === knowledge.picture);
      const src = found ? found.path : knowledge.picture?.path;
      if (src) return <img src={API_URL + '/' + src} alt="" className={className} />;
    }
    return <div className="circle"></div>;
  }

  function renderEdit() {
    return (
      <>
        <div className="btn-close-row">
          <button type="button" style={{ width: 30 }} onClick={save_}>
            <img src={save} alt="save" />
          </button>
          <button type="button" onClick={() => setIsEdit(false)}>
            <img src={close} alt="close" />
          </button>
        </div>

        <label>Texte</label>
        <input
          style={{ marginBottom: 10 }}
          value={knowledge.text || ''}
          onChange={(e) => setKnowledge({ ...knowledge, text: e.target.value })}
        />

        <label>Image <span className="note">minimum 600 x 400 px</span></label>
        <div className="btn-container">
          <button
            type="button"
            className="btn grey"
            style={{ marginRight: 20 }}
            onClick={() => openSelectKnowledgePicture(index)}
          >
            Parcourir
          </button>
          {knowledge.picture &&
            <button
              type="button"
              className="btn grey bold"
              onClick={() => setRemoveAction({ function: () => setKnowledge({ ...knowledge, picture: null }) })}
            >
              Supprimer la photo
            </button>
          }
        </div>
        <div style={{ marginBottom: 30 }}>{renderImg('img-large')}</div>
      </>
    );
  }

  function renderRow() {
    return (
      <>
        <div className="name">
          {renderImg('circle')}
          <p className="bold">{knowledge.text || <em className="text-grey">Sans texte</em>}</p>
        </div>
        <div className="actions">
          <button type="button" onClick={() => setIsEdit(true)}>
            <img src={edit} alt="edit" />
          </button>
          <button
            type="button"
            onClick={() => setRemoveAction({ function: () => setKnowledges(knowledges.filter((_, i) => i !== index)) })}
          >
            <img src={remove} alt="remove" />
          </button>
        </div>
      </>
    );
  }

  return (
    <div id={`knowledge${index}`} className={`page ${!isEdit ? 'list-item row' : 'edit'}`}>
      {isEdit ? renderEdit() : renderRow()}
    </div>
  );
}
